import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, ModalPortal } from '../../../components';
import { IconCheckCircleXXL } from '../../../icons';
import { FormattedMessage } from '../../../util/reactIntl';
import css from './ConfirmationModal.css';
import {
    getEntryDataToRedirectAfterAuth,
    removeEntryDataToRedirectAfterAuth,
} from '../../../util/localStorage';
import { createResourceLocatorString } from '../../../util/routes';
import routeConfiguration from '../../../routeConfiguration';
import { queryOwnListings } from '../../ManageListingsPage/ManageListingsPage.duck';
import { useDispatch } from 'react-redux';

const ConfirmationModal = ({ onClose, authorDisplayName }) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const entryToRedirectAfterAuth = getEntryDataToRedirectAfterAuth();

    const { params, name, redirectAfterAuthInquiryData } = entryToRedirectAfterAuth || {};
    const { riderName = 'Reiter' } = redirectAfterAuthInquiryData || {};

    const closeModal = () => {
        const urlSearchParams = ['confirmation'];
        onClose(urlSearchParams);
    };

    const handleAction = () => {
        if (redirectAfterAuthInquiryData) {
            // this entry is set on a rider's page;
            // see AcceptInquirySection.js for more info;
            // the last condition described in the component is done here:
            // -navigate the owner back to this very rider once a new horse created;

            // remove the redirect info as it is not needed anymore
            removeEntryDataToRedirectAfterAuth();

            // navigate to a rider's page
            const uri = createResourceLocatorString(name, routeConfiguration(), params);
            return history.replace(uri);
        } else {
            closeModal();
        }
    };

    const descriptionId = redirectAfterAuthInquiryData
        ? 'redirectAfterAuthDescription'
        : 'description';

    const actionButtonId = redirectAfterAuthInquiryData ? 'redirectAfterAuthAction' : 'action';

    useEffect(() => {
        /**
         * re-query an owner listing for cases when
         * he will be redirected to a rider's page
         * and start a new inquiry with him + newly created horse
         */
        if (redirectAfterAuthInquiryData) {
            dispatch(queryOwnListings({}));
        }
    }, [redirectAfterAuthInquiryData]);

    return (
        <ModalPortal
            id="listing.created.confirmation"
            containerClassName={css.modalContainer}
            contentClassName={css.modalContent}
            containerClassNameJoined
            isOpen
            onClose={closeModal}
        >
            <IconCheckCircleXXL />
            <h3 className={css.modalTitle}>
                <FormattedMessage
                    id="ConfirmationModal.title"
                    values={{ userName: authorDisplayName }}
                />
            </h3>
            <p className={css.modalMessage}>
                <FormattedMessage
                    id={`ConfirmationModal.${descriptionId}`}
                    values={{ riderName }}
                />
            </p>
            <Button type="button" onClick={handleAction}>
                <FormattedMessage
                    id={`ConfirmationModal.${actionButtonId}`}
                    values={{ riderName }}
                />
            </Button>
        </ModalPortal>
    );
};

export default ConfirmationModal;
